import { css } from '@emotion/core'
import React from 'react'

import { isMobile } from '../helpers/common'

interface ReadingProgressBarProps {
  className?: string
}

const ReadingProgressBar: React.FunctionComponent<ReadingProgressBarProps> = ({ className }) => {
  const [scrolledAmount, setScrolledAmount] = React.useState(0)

  // hiding ProgressBar on scrolling up
  const [scrollingUp, setScrollingUp] = React.useState(isMobile() ? false : true)
  const [lastScrollingPosition, setLastScrollingPosition] = React.useState(0)

  React.useEffect(() => {
    const scrollHandler = () => {
      const richTextElements = document.getElementsByClassName('rich-text')
      const topPositionOfRichText = richTextElements[0].getBoundingClientRect().top
      const bottomPositionOfRichText = richTextElements[richTextElements.length - 1].getBoundingClientRect().bottom

      // scrolledAmount calculated in % by quotient
      // added "300" to start the ProgressBar 300px above the topPositionOfRichtext
      // and be at 100% 300px above the bottomPositionOfRichtext
      setScrolledAmount(((300 - topPositionOfRichText) / (bottomPositionOfRichText - topPositionOfRichText)) * 100)

      setScrollingUp(
        topPositionOfRichText <= 300 && bottomPositionOfRichText > 100 ? window.scrollY < lastScrollingPosition : true
      )

      setLastScrollingPosition(window.scrollY)
    }

    document.addEventListener('scroll', scrollHandler)

    return () => {
      document.removeEventListener('scroll', scrollHandler)
    }
  }, [lastScrollingPosition])

  return (
    <div className={className} css={progressBarStyle(scrolledAmount, scrollingUp)}>
      <div className="progress-bar" />
    </div>
  )
}

export default ReadingProgressBar

const progressBarStyle = (scrolledAmount: number, scrollingUp: boolean) => css`
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  background: #efeff0;
  height: 0.25rem;

  // hide ProgressBar on scrolling down
  // translateY(-200%) to establish slight time delay for fade-in
  transition: transform 1s ease-out;

  ${scrollingUp && 'transform: translateY(-200%)'};
  .progress-bar {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${scrolledAmount}% !important;
    background: #318eff;
  }
`
